import { IBloodDrawConfirmationContract } from '@nkr/models/index';
import { TableWrapperSmall } from '../styles';
import ConfirmSerologyBloodDrawRow from './confirm-serology-blood-draw-row';

interface IProps {
    list: IBloodDrawConfirmationContract[],
    onConfirm: (contract: IBloodDrawConfirmationContract) => void
}

const ConfirmSerologyBloodDraw = (props: IProps) => {
    return (
        <TableWrapperSmall className='table table-striped table-condensed table-bordered'>
            <thead>
                <tr>
                    <th>Swap</th>
                    <th>Donor Center</th>
                    <th>Donor Alias</th>
                    <th>Recipient Center</th>
                    <th>Recipient Alias</th>
                    <th>Target Surgery Date</th>
                    <th>Scheduled Blood Draw Date</th>
                    <th>Confirm</th>
                </tr>
            </thead>
            <tbody>
                {props.list.map(item =>
                    <ConfirmSerologyBloodDrawRow
                        key={item.id}
                        item={item}
                        onConfirm={props.onConfirm}
                    />
                )}
            </tbody>
        </TableWrapperSmall>
    );
};

export default ConfirmSerologyBloodDraw;
